function regions() {
  return this.__execs__.canvas.selectAll(this.regionName());
}

export default regions;


// WEBPACK FOOTER //
// ./layouts/default/regions.js